module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.6e7bd3e.ttf";